
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    trackNumber: Number,
    audioContext: AudioContext,
    audioBuffer: AudioBuffer,
    playing: Boolean,
    loaded: Boolean
  }
})
export default class Transport extends Vue {
  audioContext!: AudioContext;
  audioBuffer!: AudioBuffer;
  playing!: boolean;
  loaded = false;

  get buttonText() {
    return this.playing ? "Pause" : "&#x25B6;";
  }

  get duration() {
    return this.loaded ? Math.round(this.audioBuffer.duration * 100) / 100 : 0;
  }

  get sampleDuration() {
    return this.loaded ? this.audioBuffer.length : 0;
  }

  get sampleRate() {
    return this.loaded ? this.audioBuffer.sampleRate : 0;
  }

  onPlay() {
    this.$emit("onPlay");
  }

  onStop() {
    this.$emit("onStop");
  }
}
